var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationAllApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;fill:none;stroke:#000000;stroke-width:5.000000e-02;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,4c-0.6,0-1,0.4-1,1v14c0,0.6,0.4,1,1,1s1-0.4,1-1V5C19,4.4,18.6,4,18,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4c-0.6,0-1,0.4-1,1v14c0,0.6,0.4,1,1,1s1-0.4,1-1V5C13,4.4,12.6,4,12,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,4C5.4,4,5,4.4,5,5v14c0,0.6,0.4,1,1,1s1-0.4,1-1V5C7,4.4,6.6,4,6,4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAllApps);
export default __webpack_public_path__ + "static/media/navigation_all_apps.028d124901d62a368448c2ae61282e6c.svg";
export { ForwardRef as ReactComponent };